/* =============================================================
   Solius Cart Rules  —  assets/solius-cart-rules.js
   Loaded globally on every page.

   Rules enforced after every cart/add or cart/change call,
   regardless of origin (drawer, cart page, console, apps):

     1. Lifetime sub removed if main product is not in cart
     2. Lifetime sub qty always matches main product qty
   ============================================================= */
(function () {
  'use strict';

  /* ── Hardcoded config — no dependency on PDP snippet being present ── */
  var CONFIG = {
    MAIN_PRODUCT_ID:  9334889578744,
    LIFETIME_VARIANT: 48824098947320,  /* App Subscription — Lifetime variant */
    SUB_PRODUCT_ID:   9864461811960    /* App Subscription product */
  };

  /* PDP snippet may override/extend config (e.g. with resolved LIFETIME_PLAN) */
  function cfg() {
    return window.SoliusCartRulesConfig || CONFIG;
  }

  function cartChange(payload) {
    return fetch(window.routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error(data.description || data.message || 'Cart change failed.');
        return data;
      });
    });
  }

  function isCartPage() {
    return window.location.pathname === '/cart';
  }

  function refreshCartPage() {
    var itemsEl  = document.getElementById('main-cart-items');
    var footerEl = document.getElementById('main-cart-footer');
    var bubbleEl = document.getElementById('cart-icon-bubble');
    if (!itemsEl) return Promise.resolve();

    var itemsSectionId  = itemsEl.dataset.id;
    var footerSectionId = footerEl ? footerEl.dataset.id : null;

    var sections = [
      { sectionId: itemsSectionId,  targetEl: itemsEl.querySelector('.js-contents'), sourceSelector: '.js-contents' },
      { sectionId: footerSectionId, targetEl: footerEl ? footerEl.querySelector('.js-contents') : null, sourceSelector: '.js-contents' },
      { sectionId: 'cart-icon-bubble', targetEl: bubbleEl, sourceSelector: '.shopify-section' }
    ].filter(function (s) { return s.sectionId && s.targetEl; });

    var sectionIds = sections.map(function (s) { return s.sectionId; });

    return fetch('/cart?sections=' + sectionIds.join(','), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        sections.forEach(function (s) {
          if (!data[s.sectionId]) return;
          var parser = new DOMParser();
          var parsed = parser.parseFromString(data[s.sectionId], 'text/html');
          var source = parsed.querySelector(s.sourceSelector);
          if (source) s.targetEl.innerHTML = source.innerHTML;
        });
        /* Also sync navbar badges via the helper if available */
        if (typeof syncNavbarCartBadges === 'function') {
          fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) { syncNavbarCartBadges(cart.item_count); });
        }
      })
      .catch(function (err) {
        console.error('[Solius cart rules] refreshCartPage error:', err);
      });
  }

  function refreshCart() {
    /* On the cart page — update cart sections in-place, skip drawer (it's not open) */
    if (isCartPage()) {
      return refreshCartPage();
    }

    /* Everywhere else — use renderContents which properly updates the drawer UI
       and rebinds event listeners. If the drawer is already open this is safe —
       renderContents just refreshes the content without closing/reopening it. */
    var cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (!cartEl || typeof cartEl.renderContents !== 'function') return Promise.resolve();

    var drawerOpen = cartEl.classList.contains('active') || cartEl.classList.contains('is-open');

    return Promise.all([
      fetch('/?sections=cart-drawer,cart-icon-bubble', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }),
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
    ]).then(function (results) {
      var sections = results[0];
      var cartJson = results[1];

      if (drawerOpen) {
        /* Drawer is open — use renderContents to properly refresh UI + rebind listeners */
        cartEl.renderContents({
          sections:   sections,
          item_count: cartJson.item_count,
          id:         cartJson.token
        });
      } else {
        /* Drawer is closed — only update the nav badge, no need to render drawer HTML */
        if (typeof syncNavbarCartBadges === 'function') syncNavbarCartBadges(cartJson.item_count);
      }
    }).catch(function (err) {
      console.error('[Solius cart rules] refreshCart error:', err);
    });
  }

  /* ── Track previous cart state to identify which line changed ── */
  var _prevCartState = {}; /* key → quantity */

  function snapshotCart(cartItems) {
    var snap = {};
    for (var i = 0; i < cartItems.length; i++) {
      snap[cartItems[i].key] = cartItems[i].quantity;
    }
    _prevCartState = snap;
  }

  /* ── Core enforcement — runs after every cart mutation ── */
  var _lastEnforcedKey = '';
  function enforceRules(cartItems) {
    if (window.__soliusCartRulesSuspended) {
      return;
    }
    var c = cfg();
    if (!Array.isArray(cartItems)) return;

    var mainItem     = null;
    var lifetimeItem = null;
    var subLines     = []; /* all subscription product lines */

    for (var i = 0; i < cartItems.length; i++) {
      var it = cartItems[i];
      if (String(it.product_id) === String(c.MAIN_PRODUCT_ID)) mainItem = it;
      if (String(it.product_id) === String(c.SUB_PRODUCT_ID))  subLines.push(it);
      if (String(it.variant_id) === String(c.LIFETIME_VARIANT)) lifetimeItem = it;
    }

    /* Snapshot current state for next comparison, then enforce */
    var prevSnap = _prevCartState;
    snapshotCart(cartItems);

    /* Nothing to enforce if no subscription lines in cart */
    if (!subLines.length) return;

    /* Rule 1: main product gone → remove ALL subscription lines */
    if (!mainItem) {
      var removeKey = subLines.map(function (s) { return s.key; }).join(',') + ':remove';
      if (_lastEnforcedKey === removeKey) return;
      _lastEnforcedKey = removeKey;

      /* Suspend enforcement while we remove sub lines so the cartChange
         response doesn't re-trigger rules mid-flight and hit the dedup guard. */
      window.__soliusCartRulesSuspended = true;

      Promise.all(subLines.map(function (s) {
        return cartChange({ id: s.key, quantity: 0 });
      }))
        .then(function () {
          _lastEnforcedKey = '';
          return refreshCart();
        })
        .catch(function (err) { console.error('[Solius cart rules] sub removal error:', err); })
        .finally(function () {
          window.__soliusCartRulesSuspended = false;
        });
      return;
    }

    var mainQty = mainItem.quantity;

    /* Rule 2: lifetime sub qty must mirror main product qty exactly */
    if (lifetimeItem && lifetimeItem.quantity !== mainQty) {
      var revertKey = lifetimeItem.key + ':' + lifetimeItem.quantity + '→' + mainQty;
      if (_lastEnforcedKey === revertKey) return;
      _lastEnforcedKey = revertKey;
      cartChange({ id: lifetimeItem.key, quantity: mainQty })
        .then(function () { return refreshCart(); })
        .catch(function (err) { console.error('[Solius cart rules] lifetime qty revert error:', err); });
      return;
    }

    /* Rule 3: total non-lifetime subscription qty must not exceed main product qty.
       If it does, revert ONLY the line whose qty increased (identified via prevSnap). */
    var nonLifetimeSubs = subLines.filter(function (s) {
      return String(s.variant_id) !== String(c.LIFETIME_VARIANT);
    });

    var totalSubQty = nonLifetimeSubs.reduce(function (sum, s) { return sum + s.quantity; }, 0);

    if (totalSubQty > mainQty) {
      /* Find the line that was increased vs previous state */
      var changedLine = null;
      for (var k = 0; k < nonLifetimeSubs.length; k++) {
        var line = nonLifetimeSubs[k];
        var prevQty = prevSnap[line.key];
        if (prevQty !== undefined && line.quantity > prevQty) {
          changedLine = line;
          break;
        }
      }

      /* Fallback: if we can't identify the changed line (e.g. new line added),
         revert the line with the highest quantity */
      if (!changedLine) {
        changedLine = nonLifetimeSubs.reduce(function (max, s) {
          return s.quantity > max.quantity ? s : max;
        }, nonLifetimeSubs[0]);
      }

      if (!changedLine) return;

      /* Revert changed line to main product qty (not its previous qty) */
      var otherSubsQty = nonLifetimeSubs.reduce(function (sum, s) {
        return s.key !== changedLine.key ? sum + s.quantity : sum;
      }, 0);
      var revertedQty = Math.max(0, mainQty - otherSubsQty);

      var revertKey2 = changedLine.key + ':' + changedLine.quantity + '→' + revertedQty;
      if (_lastEnforcedKey === revertKey2) return;
      _lastEnforcedKey = revertKey2;
      cartChange({ id: changedLine.key, quantity: revertedQty })
        .then(function () { return refreshCart(); })
        .catch(function (err) { console.error('[Solius cart rules] sub qty cap error:', err); });
    }
  }

  /* ── Fetch patch — intercepts ALL cart mutations globally ── */
  function patchFetch() {
    var originalFetch = window.fetch;
    if (typeof originalFetch !== 'function' || window.__soliusCartRulesPatched) return;
    window.__soliusCartRulesPatched = true;

    var WATCHED_ADD    = [window.location.origin + '/cart/add.js',    window.location.origin + '/cart/add'];
    var WATCHED_CHANGE = [window.location.origin + '/cart/change.js', window.location.origin + '/cart/change'];

    function inList(list, url) {
      for (var i = 0; i < list.length; i++) { if (list[i] === url) return true; }
      return false;
    }

    window.fetch = function () {
      var promise = originalFetch.apply(this, arguments);

      promise.then(function (res) {
        var isAdd    = inList(WATCHED_ADD, res.url);
        var isChange = inList(WATCHED_CHANGE, res.url);
        if (!isAdd && !isChange) return;

        if (isAdd) {
          /* cart/add response contains only the added item(s) — fetch full cart */
          originalFetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              enforceRules(cart.items);
            })
            .catch(function () {});
          return;
        }

        /* cart/change returns the full cart object */
        res.clone().json().then(function (data) {
          enforceRules(data.items);
        }).catch(function () {});
      });

      return promise;
    };
  }

  function init() {
    patchFetch();
    /* Snapshot current cart on load so prevSnap is populated before first mutation */
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { if (cart.items) snapshotCart(cart.items); })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
